"use strict";

if (typeof CoreMap == 'undefined') var CoreMap = {};

CoreMap.GMEAN_EARTH_RADIUS_METERS = 6367450;
CoreMap.GMEAN_EARTH_RADIUS_KM = 6367.45;
CoreMap.GMEAN_EARTH_RADIUS_MILES = 3956.55;
CoreMap.GMEAN_EARTH_RADIUS_NM = 3438.15;

// Defined projections
// SWEREF99
proj4.defs("EPSG:3006","+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");

// Spherical law of cosines
CoreMap.distanceSloc =function(lat1, lon1, lat2, lon2, R) {
    if (!R)
        R = Map.GMEAN_EARTH_RADIUS_METERS;
    var rlat1 = lat1 * Math.PI/180;
    var rlon1 = lon1 * Math.PI/180;
    var rlat2 = lat2 * Math.PI/180;
    var rlon2 = lon2 * Math.PI/180;
    var d = Math.acos(Math.sin(rlat1)*Math.sin(rlat2) +
        Math.cos(rlat1)*Math.cos(rlat2) *
            Math.cos(rlon2-rlon1)) * R;
    return d;
}

CoreMap.isSWEREF99 = function(input) {
    return input.match(/([\d]{7,7}[.]?([\d]+)?)[\s,]+([\d]{6,6}[.]?([\d]+)?)/)
}

CoreMap.SWEREF99XYToWGS85 = function(x, y) {
    console.log("Converting from sweref:",x,y)
    return proj4(proj4("EPSG:3006"), proj4("WGS84"), [x,y])
}

CoreMap.SWEREF99StringToWGS84 = function(input) {
    var x = input.split(",")[0].trim();
    var y = input.split(",")[1].trim();
    return CoreMap.SWEREF99XYToWGS85(parseInt(y), parseInt(x))
}

